export default (axios) => ({
    getCategories() {
      return axios.get(`/categories`);
    },
    getHomeCategories() {
      return axios.get(`/categories/home/category`);
    },
    getCategoryBySlug(slug='') {
      return axios.get(`/categories/${slug}`);
    },
    getHomeSubcategoriesBySlug(slug='') {
      return axios.get(`/categories/home/category/${slug}`);
    },
    getSubcategories(slug='') {
      return axios.get(`/categories/${slug}`);
    },
    getBrands() {
      return axios.get(`/brands`);
    },
  });
  